import { useSplitTreatments } from '@splitsoftware/splitio-react';

import { useAuth } from '@/auth';

type UseFeatureFlagParams = {
  name: string;
  attributes?: SplitIO.Attributes;
  splitKey?: SplitIO.SplitKey;
};

export const useFeatureFlag = ({
  name,
  attributes,
  splitKey,
}: UseFeatureFlagParams) => {
  const { user } = useAuth();
  const { treatments } = useSplitTreatments({
    names: [name],
    attributes,
    splitKey: splitKey ?? user?.sub ?? 'anonymous',
  });

  const isFlagOn = treatments?.[name]?.treatment === 'on';

  const isFlagOff = treatments?.[name]?.treatment === 'off';

  return { isFlagOn, isFlagOff };
};
